/**
 * Created by h3 on 2017-05-31.
 */
import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {TractorBeamGameModuleConfig} from "../../TractorBeamGameModuleConfig";
import {TractorBeamSoundConfig} from "../../TractorBeamSoundConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {TractorBeamGameConfig} from "../../TractorBeamGameConfig";
import {TractorBeam} from "../../TractorBeam";

export class TractorBeamFreeSpinOutroView extends ScreenView {

    private readonly DEFAULT_BUTTON:PIXI.Point = new PIXI.Point(240, 64);

    private _container:PIXI.Container;
    private _fadeAnimation:TimelineLite;
    private _youWonTitle:PIXI.Text;
    private _youWonAmount:PIXI.BitmapText;
    private _darkScreen:PIXI.Graphics = new PIXI.Graphics();
    private _bgSprite:PIXI.Sprite;
    private _orientationData:IResizeData;
    // #226
    private _winBelowStake: boolean = false;

    private _youWonTitleStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "30pt",
        fontWeight : "600",
        fill : "#e1e2d7",
        dropShadowColor : "#1d456d",
        dropShadow : true,
        dropShadowAngle : 90,
        dropShadowDistance : 2,
        //stroke : "#000000",
        //strokeThickness : 7,
    };

    private _fsCountStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "30px",
        fontWeight : "700",
        fill : "#e1e2d7",
        dropShadowColor : "#000000",
        dropShadow : true,
        dropShadowAngle : 90,
        dropShadowDistance : 6,
        stroke : "#000000",
        strokeThickness : 7,
    };

    constructor(config:IScreenViewConfig, autoClose:boolean = true) {
        super(config, autoClose);
    }

    protected initAnimations():void {
        super.initAnimations();


        this.createDarkScreen();
        this.addChild(this._darkScreen);
        this.resetScreen();

        //this._layer.addChild(this);
    }

    public show(data?:ParsedServerData, onShowComplete?:() => void):void {
        super.show(data, onShowComplete);

        //this.onResize(this._orientationData);
    }

    private createDarkScreen():void {
        this._darkScreen.beginFill(0x000000, 1);
        this._darkScreen.drawRect(0, 0, GameConfig.instance.GAME_WIDTH, GameConfig.instance.GAME_HEIGHT);
        this._darkScreen.endFill();
        this._darkScreen.alpha = 0;
    }

    protected createBackground():PIXI.Container {
        /*let blackOverlayContainer:PIXI.Container = new PIXI.Container();
        const blackOverlay:PIXI.Graphics = new PIXI.Graphics();
        blackOverlay.beginFill(0x000000, 1);
        blackOverlay.drawRect(0, 0, TractorBeamGameConfig.instance.GAME_WIDTH, TractorBeamGameConfig.instance.GAME_HEIGHT);
        blackOverlay.endFill();
        blackOverlayContainer.addChild(blackOverlay);
        blackOverlayContainer.alpha = 0;
        return blackOverlayContainer;*/
        return new PIXI.Container();
    }

    private fadeInElements():Timeline {
        const tl:TimelineLite = new TimelineLite();


        tl.add(TweenLite.fromTo(this._darkScreen, 1.5, {
            alpha : 0
        }, {
            alpha : 1
        }));
        tl.add([
            () => {
                this.alpha = 1;
                this._bgSprite.alpha = 1;
                this._youWonAmount.alpha = 1;
                this._youWonTitle.alpha = 1;
                this._button.visible = true;
                // this._autoCloseTimer.visible = true;
                this._background.alpha = 1;
            },
            TweenLite.fromTo(this._darkScreen, 0.5, {alpha : 1}, {alpha : 0}),
            () => {
                // #226
                !this._winBelowStake && SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.FS_OUTRO);
            }
        ]);
        tl.add([
            () => {
                TractorBeamGameModuleConfig.soundPlayer.switchToMainMusic();
            }
        ], "+=0.2");

        return tl;
    }

    protected createGameGraphics():PIXI.DisplayObject {
        this._container = new PIXI.Container();

        const bg:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("fsOutro")[0]);
        bg.anchor.set(0.115, 0.29);
        this._bgSprite = bg;
        //this._bgSprite.x = 50;
        //bg.anchor.set(0.115, 0.275);
        /**Left tip of some characters are cut if there is no space added at the beginning. example: "je winst" in dutch for "you won"
         Might be something regarding pixi text.*/
        this._youWonTitle = new PIXI.Text(Translation.translate("You won"), this._youWonTitleStyle);
        this._youWonTitle.anchor.set(0.5, 0.5);
        //this._youWonTitle.position.set(0, -90);

        this._youWonAmount = new PIXI.BitmapText("", {
            fontName : "yetiCountUp",
            fontSize : 87,
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        this._youWonAmount.anchor = 0.5;
        this._youWonAmount.position.set(300, 600);

        this._youWonTitle.position.set(650, 200);
        this._youWonAmount.position.set(650, 300);

        this._container.y = 0;
        this._bgSprite.x = 75;
        this._bgSprite.y = 0;

        this.addChild(this._bgSprite);
        //this._container.addChild(this);
        this.addChild(this._youWonTitle);
        this.addChild(this._youWonAmount);

        return this._container;
    }

    protected startPresentation(data?:ParsedGameData, onShowComplete?:() => void):void {
        super.startPresentation(data, onShowComplete);
        this._winBelowStake = false;
        this.onResize(this._orientationData);
        if(data) {
            this.updateTexts(data);
            // #226
            this._winBelowStake = (TractorBeam.api.gameClientConfiguration.belowStakeWinRestriction && (data.totalWin <= data.playedBetValue));
        }
        this.fadeInElements();
    }

    protected stopPresentation(closeCallback?:() => void):void {
        const tl:Timeline = new TimelineLite({
            "onComplete: " : () => {
                //this.resetScreen();
                //super.stopPresentation(closeCallback);
            }
        });

        tl.add([
            () => EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : "NORMAL"})),
            () => TractorBeamGameModuleConfig.background.setBg(),
            TweenLite.fromTo(this, 0.5, {
                alpha : 1
            }, {
                alpha : 0
            })
        ]);
        tl.add([
            () => TractorBeamGameModuleConfig.background.zoomAndPane(false),
            () => this.resetScreen(),
            () => super.stopPresentation(closeCallback)
        ]);
        //this.resetScreen();
    }

    private updateTexts(data:ParsedServerData):void {
        this._youWonAmount.text = ` ${Currency.formatValue(data.totalWin)} `;
    }

    protected onResize(resizeData:IResizeData):void {
        const screenWidth = resizeData.width / this._layer.scale.x;
        const screenHeight = resizeData.height / this._layer.scale.y;
        const leftOffset = -this._layer.x / this._layer.scale.x;
        const topOffset = -this._layer.y / this._layer.scale.y;
        this._orientationData = resizeData;
        //super.onResize(resizeData);

        this._orientationScale = resizeData.orientation === Orientation.PORTRAIT ? (this._config.portraitScale ? this._config.portraitScale : this.DEFAULT_PORTRAIT_SCALE) : 1;


        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._container.y = 100;
            this._bgSprite.x = -120;
            this._bgSprite.y = 65;
            this._bgSprite.scale.set(1.2, 1.2);
            this._youWonTitle.position.set(650, 400);
            this._youWonAmount.position.set(650, 500);
        } else {

            if(UserAgent.isMobile) {
                this._youWonTitle.position.set(650, 250);
                this._youWonAmount.position.set(650, 350);
            } else {
                this._youWonTitle.position.set(650, 300);
                this._youWonAmount.position.set(650, 400);
            }

            this._bgSprite.scale.set(1, 1);

            this._container.y = 0;
            this._bgSprite.x = 0;
            this._bgSprite.y = 0;
        }

        this.onResizeButton(resizeData);
        this.onResizeAutoCloseTimer(resizeData);

        this._darkScreen.x = leftOffset;
        this._darkScreen.y = topOffset;
        this._darkScreen.width = screenWidth;
        this._darkScreen.height = screenHeight;


        //this._bgSprite.anchor.set(0.5, 0.5);
        //this._bgSprite.position.set(450, 200);
        //this._container.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);
    }


    private resetScreen():void {
        this._bgSprite.alpha = 0;
        this._youWonAmount.alpha = 0;
        this._youWonTitle.alpha = 0;
        this._background.alpha = 0;
        this._button.visible = false;
        // this._autoCloseTimer.visible = false;
    }

    private getScaledButton():PIXI.Point {
        const buttonSize:PIXI.Point = this._config.buttonSize ? this._config.buttonSize : this.DEFAULT_BUTTON;
        return new PIXI.Point(buttonSize.x * this._deviceScale, buttonSize.y * this._deviceScale);
    }

    protected onResizeAutoCloseTimer(data:IResizeData):void {
        // const scale:number = this._orientationScale * this._deviceScale;//(data.orientation === Orientation.PORTRAIT)? 2 : 1.75;
        // this._autoCloseTimer.setScale(scale);
        // this._autoCloseTimer.position.set(this._button.x, this._button.y + this._button.height * 0.5 + this._autoCloseTimer.height);
    }

    protected onResizeButton(data:IResizeData):void {
        const buttonSize:PIXI.Point = this.getScaledButton();
        this._button.setSize(buttonSize.x, buttonSize.y, 1);

        if(data.orientation === Orientation.PORTRAIT) {
            this._button.scale.set(1, 1);
        } else {
            this._button.scale.set(1, 1);
        }


        this.setButtonPosition(data);
    }

    protected setButtonPosition(data:IResizeData):void {
        if(data.orientation === Orientation.PORTRAIT) {
            this._button.position.set(650, 795)
        } else {
            if(UserAgent.isMobile) {
                this._button.position.set(650, 500);
            } else {
                this._button.position.set(650, 625);
            }
        }
    }
}
